var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3039 1.19557C10.3039 1.85451 10.832 2.39122 11.4804 2.39122C15.1562 2.39122 18.1471 5.43084 18.1471 9.16659C18.1471 12.9023 15.1562 15.9419 11.4804 15.9419C7.80457 15.9419 4.81373 12.9023 4.81373 9.16659L6.77451 9.16659L3.63725 4.38398L0.5 9.16659L2.46078 9.16659C2.46078 14.2202 6.50784 18.3333 11.4804 18.3333C16.4529 18.3333 20.5 14.2202 20.5 9.16659C20.5 4.11296 16.4529 -8.0806e-05 11.4804 -8.05886e-05C10.832 -8.05603e-05 10.3039 0.536634 10.3039 1.19557Z",
    fill: "url(#paint0_linear_548_2436)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_548_2436",
    x1: 0.5,
    y1: -0.0000818349,
    x2: 29.3196,
    y2: 20.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DFE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#3ACBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6055FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.5574320090911daaddd5df735542e8b5.svg";
export { ForwardRef as ReactComponent };